/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable promise/prefer-await-to-then */
import { isPresent } from '@ember/utils';
import { inject as service } from '@ember/service';
import ENV from 'embercom/config/environment';
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { task } from 'ember-concurrency';
import md5 from 'blueimp-md5';
import { encodedVapidToken } from 'embercom/lib/vapid-token';
import { computed } from '@ember/object';
import UserAgentDetector from '@intercom/pulse/lib/user-agent-detector';
import { getOwner } from '@ember/application';
import Metrics from 'embercom/models/metrics';
import Admin from 'embercom/models/admin';
import Theme from 'embercom/objects/inbox/types/theme';
import { request } from 'embercom/lib/inbox/requests';

export default IntercomRoute.extend({
  store: service(),
  pubsub: service(),

  themeService: service(),
  conversationsService: service(),
  bootService: service(),
  router: service(),
  intl: service(),
  shortcuts: service(),
  modelDataCacheService: service(),
  encodedVapidToken: computed('ENV.environment', function () {
    return encodedVapidToken();
  }),

  async beforeModel(transition) {
    if (sessionStorage) {
      try {
        let tabIdentifier =
          ENV.environment === 'test'
            ? 'test_tab'
            : `${new Date().toISOString()}::${md5(Math.random())}`;
        sessionStorage.setItem('embercom_tab_identifier', tabIdentifier);
      } catch (e) {
        // Do nothing
      }
    }

    if (transition.to.name === 'apps.app.copilot-frame') {
      let app_id = transition.to.parent.params.app_id;

      try {
        if (location.search.includes('theme=dark')) {
          this.themeService.setForcedTheme(Theme.Dark);
        } else {
          this.themeService.setForcedTheme(Theme.Light);
        }
        await Admin.meWithoutRedirect();
      } catch (e) {
        this.router.transitionTo(
          'frame-login',
          {
            redirect_url: window.location.href,
          },
          { queryParams: { app_id } },
        );
      }
    }
  },

  adminModelId() {
    if (isPresent(window.__embercom_boot_data)) {
      return window.__embercom_boot_data.current_admin_id;
    }
  },

  async model() {
    let model = await this.modelDataCacheService.fetch('admin', this.adminModelId());

    await this.intl.switchLocale(model.locale);

    return model;
  },

  afterModel(model) {
    this.set('admin', model);
    this.conversationsService.set('admin', model);

    this.bootService.ifOrWhenSecondaryStageReached().then(() => {
      let admin = this.admin;
      let appRoute = getOwner(this).lookup('route:apps/app');
      let app = appRoute.app;

      this.bootShortcuts(admin);
      // Fire-and-forget: run health check in background without blocking user experience
      this.checkNotificationSettings(app, admin);
    });
  },

  checkNotificationSettings(app, admin) {
    let hasServiceWorkers = 'serviceWorker' in navigator;
    let isImpersonationSession = app && app.get('impersonation_session');

    if (isImpersonationSession || !hasServiceWorkers) {
      return;
    }

    this.promptForPushPermissionIfRequired.perform(app, admin).catch(() => {
      // Only catching so acceptance tests don't fail
    });
  },

  bootShortcuts(admin) {
    let state = {
      advancedEnabled: admin.get('advanced_shortcuts_enabled'),
      csEnabled: admin.get('hasEnabledCSComponent'),
    };
    let pubsub = this.pubsub;
    this.shortcuts.setProperties({ state, pubsub });
  },

  promptForPushPermissionIfRequired: task(function* (app, admin) {
    let serviceWorkerRegistration;
    let options = { userVisibleOnly: true };
    if (UserAgentDetector.isChrome()) {
      options.applicationServerKey = this.encodedVapidToken;
    }
    if (ENV.environment === 'test' && navigator.serviceWorker.fakeReady) {
      serviceWorkerRegistration = yield navigator.serviceWorker.fakeReady();
    } else {
      serviceWorkerRegistration = yield navigator.serviceWorker.ready;
    }
    let pushManager = serviceWorkerRegistration.pushManager;
    let permissionState = yield pushManager.permissionState(options);

    if (permissionState === 'denied') {
      return;
    }

    let existingPushSubscription = yield pushManager.getSubscription();

    if (existingPushSubscription) {
      let isLegacyGCMEndpoint = existingPushSubscription.endpoint.startsWith(
        'https://android.googleapis.com/gcm/send',
      );
      if (isLegacyGCMEndpoint) {
        Metrics.capture({ increment: ['gcm_unsubscribe_token'] });
        yield existingPushSubscription.unsubscribe();
      } else {
        // Health check: Verify Chrome FCM endpoint is still valid in backend
        let canRunHealthCheck =
          app.canUseFeature('ps-web-push-auto-resubscribe-chrome-fcm') &&
          UserAgentDetector.isChrome() &&
          typeof Notification !== 'undefined' &&
          Notification.permission === 'granted';

        if (!canRunHealthCheck) {
          return;
        }

        // Check if backend have the Chrome FCM endpoint
        try {
          let response = yield request(
            `/ember/web_push_endpoints/has_chrome_fcm_endpoint?app_id=${app.get('id')}`,
          );
          let data = yield response.json();
          let endpointStatus = data.has_chrome_fcm_endpoint;

          if (endpointStatus === 'not_available' || endpointStatus === true) {
            return;
          }

          if (endpointStatus === false) {
            yield existingPushSubscription.unsubscribe();
          }
        } catch (e) {
          // If health check API call fails, don't risk unsubscribing
          return;
        }
      }
    }

    let settings = yield this.store.findRecord('admin-notification-settings', admin.get('id'));
    if (settings.get('hasAnyWebPush')) {
      try {
        let pushSubscription = yield pushManager.subscribe(options);
        yield settings.savePushSubscription(app, admin, pushSubscription);
      } catch (e) {
        // User denied permission, it would be a bit rude to do anything now
      }
    }
  }),

  actions: {
    refreshAppsAdminModel() {
      this.refresh();
    },
  },
});
